module.exports = __webpack_public_path__ + "img/icon_code.5fdc4ac2.jpg";